import type { PublicServiceDetail } from "@/v2-status-client/status/status.types"
import StatusCategoryServiceItem from "@/v2-status-client/status/category/StatusCategoryServiceItem"

export type StatusCategoryServiceListProps = {
  services: PublicServiceDetail[]
}

// Inline list of services for a category; rendered when the
// operator expands a category row. Empty state is intentionally
// terse -- the parent already shows "No services configured yet"
// in the category summary, so the list just folds away.
//
// The list itself is intentionally chrome-free (no border, no
// background, no rounded corners). The surrounding accordion
// content already provides the card surface and padding, and each
// row carries its own bottom divider, so wrapping the list in
// another box only added a third frame nested inside the others.
function StatusCategoryServiceList(
  props: Readonly<StatusCategoryServiceListProps>,
) {
  if (props.services.length === 0) {
    return (
      <div className="px-1 pb-2 text-xs text-muted-foreground">
        No individual services to show.
      </div>
    )
  }
  return (
    <ul className="m-0 list-none px-0">
      {props.services.map((s) => (
        <StatusCategoryServiceItem key={s.id} service={s} />
      ))}
    </ul>
  )
}

export default StatusCategoryServiceList
